import { render } from "./ViewInfoFooterPage.vue?vue&type=template&id=bf56ac46&ts=true"
import script from "./ViewInfoFooterPage.vue?vue&type=script&lang=ts"
export * from "./ViewInfoFooterPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__